import { WebsitesContainer } from '@/modules/Websites';

export const Websites = (): JSX.Element => <WebsitesContainer />;

export default Websites;
